// CUSTOM CODE

jQuery(document).ready(function($) {

  setInterval(function() {
    if ($('[data-header-toolbar-direction="next"]').attr('data-disabled') == 'false') {
      $('[data-header-toolbar-direction="next"]')[0].click();
    } else {
      $('[data-header-toolbar-direction="previous"]')[0].click();
    }
  }, 12000);

  $('body.template-product .product-block--product_label').on('click', function(e) {
    e.preventDefault();
    window.location = 'https://www.fishersfinery.com/pages/sustainability';
  });
  
});
